var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrightLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "url(#paint0_linear_429_15292)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_15292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09682 9.45712C6.14897 9.31518 6.34973 9.31518 6.40188 9.45712L6.71782 10.317C6.88229 10.7646 7.23507 11.1174 7.68268 11.2819L8.54255 11.5978C8.6845 11.6499 8.6845 11.8507 8.54255 11.9029L7.68268 12.2188C7.23507 12.3833 6.88229 12.736 6.71782 13.1837L6.40188 14.0435C6.34973 14.1855 6.14897 14.1855 6.09682 14.0435L5.78088 13.1837C5.61641 12.736 5.26363 12.3833 4.81602 12.2188L3.95614 11.9029C3.8142 11.8507 3.8142 11.6499 3.95614 11.5978L4.81602 11.2819C5.26363 11.1174 5.61641 10.7646 5.78088 10.317L6.09682 9.45712Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0565 7.83212C12.1086 7.69018 12.3094 7.69018 12.3615 7.83212L12.823 9.08811C12.9875 9.53573 13.3402 9.88851 13.7879 10.053L15.0439 10.5145C15.1858 10.5666 15.1858 10.7674 15.0439 10.8195L13.7879 11.281C13.3402 11.4455 12.9875 11.7983 12.823 12.2459L12.3615 13.5019C12.3094 13.6438 12.1086 13.6438 12.0565 13.5019L11.595 12.2459C11.4305 11.7983 11.0777 11.4455 10.6301 11.281L9.37411 10.8195C9.23217 10.7674 9.23217 10.5666 9.37411 10.5145L10.6301 10.053C11.0777 9.88851 11.4305 9.53573 11.595 9.08811L12.0565 7.83212Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26414 2.95712C8.31629 2.81518 8.51704 2.81518 8.5692 2.95712L9.17623 4.60924C9.3407 5.05685 9.69348 5.40963 10.1411 5.57409L11.7932 6.18113C11.9351 6.23328 11.9351 6.43403 11.7932 6.48619L10.1411 7.09322C9.69348 7.25769 9.3407 7.61047 9.17623 8.05808L8.5692 9.7102C8.51704 9.85214 8.31629 9.85214 8.26414 9.7102L7.6571 8.05808C7.49264 7.61047 7.13986 7.25769 6.69224 7.09322L5.04013 6.48619C4.89819 6.43403 4.89819 6.23328 5.04013 6.18113L6.69224 5.57409C7.13986 5.40963 7.49264 5.05685 7.6571 4.60923L8.26414 2.95712Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_15292",
    x1: 9,
    y1: 6.08824,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9252E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3CE5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_15292"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightLogo);
export default __webpack_public_path__ + "static/media/BrightLogo.93307ab326b3d2a7f31e06961a6f7371.svg";
export { ForwardRef as ReactComponent };